import { AiOutlineFile, AiOutlineFilePdf, AiOutlineFileText, AiOutlineFileImage, AiOutlineFileExcel, AiOutlineFileWord } from "react-icons/ai";
import { LiaFilePowerpoint, LiaFileExcel, LiaFileWord, LiaFilePdf } from "react-icons/lia";
import { SiJavascript, SiCss3, SiHtml5, SiReact } from "react-icons/si";

const FILE_ICONS: { [key: string]: JSX.Element } = {
  js: <SiJavascript />,
  css: <SiCss3 />,
  html: <SiHtml5 />,
  jsx: <SiReact />,
  pdf: <LiaFilePdf />,
  txt: <AiOutlineFileText />,
  png: <AiOutlineFileImage />,
  jpg: <AiOutlineFileImage />,
  jpeg: <AiOutlineFileImage />,
  gif: <AiOutlineFileImage />,
  svg: <AiOutlineFileImage />,
  xls: <LiaFileExcel />,
  xlsx: <LiaFileExcel />,
  doc: <LiaFileWord />,
  docx: <LiaFileWord />,
  ppt: <LiaFilePowerpoint />,
  pptx: <LiaFilePowerpoint />,
};

export default FILE_ICONS; 